import {
    AXNUIContent,
    AXNUILayout
} from "@iddataweb/idw-common-ui/types";
import { resources } from "@constants/hardcoded-strings";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { ThemingLandingPageValidationErrors } from "@idw-types/common/validation/common/theming-validation-errors";
import { BaseRedirectUrl } from "@idw-types/redirect-url-information";

type AXNUIContentMockRPContentError = {
    approveMessageHTMLError: React.ReactNode;
    denyMessageHTMLError: React.ReactNode;
    asiLabelError: React.ReactNode;
};

export const getThemingLandingPageValidationErrors = (
    isUsingThemedUI: boolean,
    isDisplayResultsEnabled: boolean,
    redirectUrls: Array<BaseRedirectUrl>,
    axnuiContent: AXNUIContent,
    axnuiLayout: AXNUILayout
): ThemingLandingPageValidationErrors => {
    let count = 0;

    const errorObject: { [key: string]: AXNUIContentMockRPContentError } = {};

    if (isUsingThemedUI && isDisplayResultsEnabled) {
        if (redirectUrls.length > 0) {
            redirectUrls.forEach(redirectURL => {
                let approveMessageHTMLError = null;
                let denyMessageHTMLError = null;
                let asiLabelError = null;

                if (axnuiContent.mockRP[redirectURL.url]?.approveMessageHTML === "") {
                    count += 1;
                    approveMessageHTMLError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
                }
                if (axnuiContent.mockRP[redirectURL.url]?.denyMessageHTML === "") {
                    count += 1;
                    denyMessageHTMLError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
                }
                if (axnuiLayout.mockRP[redirectURL.url]?.showAsiLabel && axnuiContent.mockRP[redirectURL.url]?.asiLabel === "") {
                    count += 1;
                    asiLabelError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
                }

                errorObject[redirectURL.url] = {
                    approveMessageHTMLError,
                    denyMessageHTMLError,
                    asiLabelError
                };
            });
        }
    }

    return {
        count,
        errorObject,
        tabTitle: <TabTitleWithErrorCount
            tabName={resources.pages.verificationServiceDetails.tabs.theming.subTabs.landingPage.tabName}
            errorCount={count}
        />
    };
}